"use client";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-hot-toast"; // Make sure you import toast if you use it

// ✅ Create Axios instance that automatically sends cookies
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // ✅ Ensures HTTP-only cookies are sent with requests
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Store user info after login
export const storeAuthData = (responseData) => {
  const { user } = responseData;

  if (user) {
    Cookies.set("user", JSON.stringify(user));
    Cookies.set("userRole", user.role || "user");
    Cookies.set("userId", user.userId);
    Cookies.set("userName", user.fullname);
  }
};

// ✅ Request Interceptor - No need to manually attach Authorization for HTTP-only cookies
api.interceptors.request.use(
  (config) => {
    // The token will be sent automatically via HTTP-only cookies
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response Interceptor - Handle expired sessions
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      // Clear client-side cookies
      Cookies.remove("user");
      Cookies.remove("userRole");
      Cookies.remove("userId");
      Cookies.remove("userName");

      toast.error("Session expired. Please log in again.");

      setTimeout(() => {
        window.location.href = "/login";
      }, 1000);
    }

    return Promise.reject(error);
  }
);

export default api;
